import React, { useEffect, useState } from 'react';
import '../style/APropos.css';

const APropos = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.querySelector('.a-propos');
      if (section) {
        const scrollPosition = window.scrollY + 300;
        const sectionTop = section.offsetTop;
        if (scrollPosition >= sectionTop) {
          setIsVisible(true);
        }
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="a-propos" className="a-propos">
      <div className="container">
        <div className={`a-propos-content ${isVisible ? 'fade-in-up' : 'opacity-0'}`}>
          <h2>À propos de nous</h2>
          <div className="separator"></div>
          <p className="a-propos-description">
           Beverly Hills Construction est une entreprise de BTP basée à Denver,
à Douala-Cameroun et à Batié; spécialisée dans la location d’engins de travaux
publics, notre parc comprend des bulldozers des pelles hydrauliques
des compacteurs des niveleuses des camions bennes et des
tractopelles disponibles à la journée ou au mois avec ou sans opérateur.

Nous intervenons sur tout le Cameroun pour vos
terrassements vos routes et vos chantiers de construction,
notre priorité est de vous fournir des engins fiables pour des
travaux propres et dans les délais.
          </p>
          <div className="a-propos-grid">
            <div className="a-propos-card">
              <h3>Notre mission</h3>
              <p>Fournir des engins fiables et des services de qualité pour tous vos chantiers au Cameroun</p>
            </div>
            <div className="a-propos-card">
              <h3>Nos valeurs</h3>
              <p>Transparence professionnalisme et respect des délais</p>
            </div>
            <div className="a-propos-card">
              <h3>Notre engagement</h3>
              <p>Des équipements entretenus et des opérateurs qualifiés à votre service</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default APropos;